import { connect } from 'react-redux';

import Footer from '../../../../components/Templates/A/Footer';

const mapStateToProps = ({ app }) => ({
  helpSupport: app.getIn(['footer', 'helpSupport'], []),
  socials: app.getIn(['footer', 'socials'], []),
  department: app.getIn(['footer', 'department'], []),
  description: app.getIn(['footer', 'description'], ''),
  ebitId: app.getIn(['config', 'ebitId']),
  asPath: app.getIn(['asPath']),
});

export default connect(mapStateToProps)(Footer);
